export default __webpack_public_path__ + "static/media/Group22.6e5c7a5b.png";